import { bootstrapApplication } from '@angular/platform-browser'

import { provideCharts, withDefaultRegisterables } from 'ng2-charts'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

// Merge the charts provider into the existing appConfig.providers array
const mergedConfig = {
  ...appConfig,
  providers: [...(appConfig.providers || []), provideCharts(withDefaultRegisterables())],
}

bootstrapApplication(AppComponent, mergedConfig).catch(() => undefined)
